import {
    DealerClient_V1,
    DealerLocationDTO,
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';

export default class DealerService {
    private readonly _dealerClient: DealerClient_V1;

    constructor() {
        this._dealerClient = new DealerClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public CompanyLocations(): Promise<Array<DealerLocationDTO>> {
        return this._dealerClient.locationsByCompany();
    }

    public Locations(): Promise<Array<DealerLocationDTO>> {
        return this._dealerClient.locations();
    }
}